import {Inbox} from "../api";

export function isValidDocumentType(inbox?: Inbox, contentType?: string) {
	return contentType
		? inbox?.assignedInvoiceDocumentTypes.map(documentType => documentType.mimeType).includes(contentType)
		: false;
}

export function isValidAttachmentType(inbox?: Inbox, contentType?: string) {
	return contentType
		? inbox?.assignedAttachmentDocumentTypes.map(documentType => documentType.mimeType).includes(contentType)
		: false;
}
